import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useRouter } from '../../router';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, FormField, Link, Modal, Pagination, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiCheck, mdiCheckAll, mdiClockAlertOutline, mdiRefresh } from '@mdi/js';
import { Icon } from '@mdi/react';
import DPModal from '../../../../components/DPModal';
import Favorites from '../../../../components/extras/Favorites';
import SelectPaging from '../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../commons/functions';


type ItemEmail = { idEmail: number; hora: string; subject: string; emTo: string; emReplyTo: string; status: number, wasRead: string, url: string, body: string, fecha: string; sent: number, jsonFiles: any };

export const SystemEmails = () => {
    const { menu, parameters } = useGlobalState();

    const { navigate } = useRouter();
    const [currentPageIndex, setCurrentPageIndex] = useState(1);

    const [emails, setEmails] = useState<ItemEmail[]>([]);
    const [email, setEmail] = useState<ItemEmail>();
    const [modalPreview, setModalPreview] = useState(false);
    const [datePickerOpen, setDatePickerOpen] = useState(false);
    const [modalSubject, setModalSubject] = useState('');

    const [filterValue, setFilterValue] = useState("");

    useEffect(() => {
        if (parameters.date && parameters.date !== "")
            handleRefresh()
    }, [parameters.date]);

    const handlePreview = async (id: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/system/emails/get',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idEmail: id
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.email) {
                setEmail(data.email)
                setModalPreview(true);
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleRefresh = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/system/emails/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    date: parameters.date
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.emails) {
                setEmails(data.emails)
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const filteredEmails = emails.filter((item) => {
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.subject, item.emReplyTo, item.emTo].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });

    const paginatedEmails = filteredEmails.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);

    const getCleanFullHtml = (htmlString: any) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        // Select and remove the tracking pixels
        const trackingPixels = doc.querySelectorAll('img[src*="app.planeadores.cl/resources/emails/track"]');
        trackingPixels.forEach(img => img.remove());

        // Use outerHTML on the documentElement to get the <html>...</html> string
        return doc.documentElement.outerHTML;
    };
    const sanitizedHtml = getCleanFullHtml(email?.body ?? "");
    //}, [emails]);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={
                        <Favorites />

                    }>Bitácora de emails</Header>

                    <Table
                        stripedRows
                        variant="embedded"
                        onRowClick={({ detail }) => {
                            //console.log(detail.item);
                            handlePreview(detail.item.idEmail);
                        }}

                        columnDefinitions={[
                            {
                                id: 'idEmail',
                                header: 'Hora',
                                cell: (item: ItemEmail) => (
                                    item.hora
                                )
                            },
                            {
                                id: 'subject',
                                header: 'Asunto',
                                cell: (item: ItemEmail) => (
                                    item.subject
                                )
                            },
                            {
                                id: 'emTo',
                                header: 'Destinatario',
                                cell: (item: ItemEmail) => (
                                    item.emTo
                                )
                            },
                            {
                                id: 'status',
                                header: '',
                                cell: (item: ItemEmail) => (
                                    <>

                                        {item.sent === 0 ? <Icon path={mdiClockAlertOutline} size={1} color={"#ff8800ff"} /> :
                                            item.wasRead === "" ?
                                                <Icon path={mdiCheck} size={1} /> : <Link><Icon path={mdiCheckAll} size={1} /></Link>

                                        }
                                    </>
                                )
                            },
                        ]}

                        pagination={

                            <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                {filteredEmails.length > parameters.pageSize && (
                                    <Pagination
                                        currentPageIndex={currentPageIndex}
                                        pagesCount={Math.ceil(filteredEmails.length / parameters.pageSize)}
                                        onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                    />
                                )}
                                {emails.length > 0 && emails.length > parameters.pageSize && (
                                    <SelectPaging onSelect={(pageSize) => {
                                        setCurrentPageIndex(1);
                                        setParameters({ ...parameters, pageSize: pageSize });
                                    }} />
                                )}
                            </SpaceBetween>
                        }
                        stickyHeader

                        filter={
                            <SpaceBetween direction="horizontal" size="xs">
                                <TextFilter

                                    filteringPlaceholder="Filtrar"
                                    filteringText={filterValue}
                                    onChange={({ detail }) => {
                                        setFilterValue(detail.filteringText);
                                        setCurrentPageIndex(1);
                                    }}
                                />
                                <DPModal date={parameters.date}
                                    end={new Date()}
                                    today
                                    yesterday
                                    onConfirm={(dateString: string) => {
                                        setParameters({ ...parameters, date: dateString });
                                    }} />
                                <Button style={{ root: btnIconForm }} onClick={() => handleRefresh()}><Icon path={mdiRefresh} size={1} /></Button>
                            </SpaceBetween>
                        }
                        items={paginatedEmails}
                    />
                    <Modal size="large" visible={modalPreview} onDismiss={() => setModalPreview(false)} header={<Header>Asunto: {email?.subject}</Header>}>
                        <SpaceBetween size="s" direction="vertical">
                            <SpaceBetween size="s" direction="horizontal">
                                <FormField label="Enviado">
                                    {email?.fecha} {email?.hora}
                                </FormField>
                                <FormField label="Fecha lectura">
                                    {email?.wasRead !== "" ? email?.wasRead : "No leído"}
                                </FormField>
                                <FormField label="Fuente">
                                    <Link href={email?.url} external>Ver original</Link>
                                </FormField>
                            </SpaceBetween>
                            {email?.jsonFiles && email?.jsonFiles.length > 0 && (
                                <FormField label="Archivos adjuntos">
                                    {email?.jsonFiles.map((file: string, index: number) => (
                                        <Link key={index} onClick={() => window.open(file)} >{file.split('/').pop()}</Link>
                                    ))}
                                </FormField>
                            )}
                            <iframe
                                title="Email Preview"
                                style={{ width: "100%", height: "80vh", border: "none" }}
                                srcDoc={sanitizedHtml}
                            />
                            {JSON.stringify(email?.jsonFiles, null, 2)}
                        </SpaceBetween>
                    </Modal>


                </SpaceBetween>
            }
        />
    );
};
